interface MarkingLinesFieldProps {
  lines: Array<{ id: string; name: string }>;
  selected: string[];
  onChange: (lineIds: string[]) => void;
}

/**
 * Spec 084 (FR-001a) — as linhas em que a característica é informada NA ORIGEM. Nas demais ela só
 * aparece por herança e nunca é pedida.
 */
export function MarkingLinesField({ lines, selected, onChange }: MarkingLinesFieldProps) {
  const marcadas = new Set(selected);
  return (
    <fieldset className="space-y-2">
      <legend className="text-[13px] font-medium text-text-primary">Linhas de marcação</legend>
      <p className="text-[12px] text-text-secondary">
        Onde a característica é informada. Nas linhas seguintes da cadeia ela chega por herança.
      </p>
      {lines.length === 0 ? (
        <p className="text-[12px] text-text-tertiary">Nenhuma linha cadastrada.</p>
      ) : (
        <ul className="grid gap-1 sm:grid-cols-2">
          {lines.map((l) => (
            <li key={l.id} className="flex items-center gap-2 text-[13px]">
              <input
                type="checkbox"
                id={`marking-line-${l.id}`}
                className="accent-rd-primary-500 h-3.5 w-3.5"
                checked={marcadas.has(l.id)}
                onChange={() =>
                  onChange(
                    marcadas.has(l.id) ? selected.filter((id) => id !== l.id) : [...selected, l.id]
                  )
                }
              />
              <label htmlFor={`marking-line-${l.id}`} className="text-text-primary">
                {l.name}
              </label>
            </li>
          ))}
        </ul>
      )}
    </fieldset>
  );
}
